import sanitizeHtml from 'sanitizeHtml';

const sanitize = (el, { expression }, { effect, evaluate }) => {

    effect(() => {
        const result = evaluate(expression);

        el.innerHTML = sanitizeHtml(result, {
            allowedTags: [],
            allowedAttributes: []
        });
    });

};

export { sanitize };